import React from 'react'
import { useNavigate } from 'react-router-dom'

const datas = [
    {
        title : "New Arrival",
        content : "NEW IN",
        image : "assets/banner/shop-banner-33.jpg"
    },
    {
        title : "Upcoming",
        content : "NEW IN",
        image : "assets/banner/shop-banner-34.jpg"
    },
    {
        title : "Flat 50% off",
        content : "NEW IN",
        image : "assets/banner/shop-banner-35.jpg"
    }
]

const Banner = () => {
  const navigate = useNavigate()
  return (
    <div className='w-full p-5 px-3 flex flex-col md:flex-row gap-3 md:gap-0 justify-between'>
      {
        datas.map((data,index)=>(
            <div key={index} className=' max-w-[402px] h-[402px] relative overflow-hidden flex justify-center items-center'>
                <img src={data.image} alt={`product${index}`} className=' w-full h-full object-cover object-center hover:scale-110 duration-200 ease-in'/>
                <div className=' bg-white absolute px-6 py-4 flex flex-col text-center justify-center items-center gap-3'>
                    <h4 className=' text-red-600 font-light uppercase'>{data.content}</h4>
                    <h3 className=' text-[20px] font-bold capitalize'>{data.title}</h3>
                    <button className=' text-white bg-black px-4 py-2 text-[12px] font-bold w-fit' onClick={()=>navigate('/shop')}>Shop Now</button>
                </div>
            </div>
        ))
      }
    </div>
  )
}

export default Banner
